
import React from 'react';
import { Link } from 'react-router-dom';

interface FooterLink {
  text: string;
  url: string;
  isExternal: boolean;
}

interface FooterLinksColumnProps {
  title: string;
  links: FooterLink[];
  icon?: React.ReactNode;
}

const FooterLinksColumn = ({ title, links, icon }: FooterLinksColumnProps) => {
  return (
    <div>
      <h4 className="font-semibold text-brand-darkgrey mb-4 flex items-center gap-1">
        {icon}
        {title}
      </h4>
      <ul className="space-y-3">
        {links.map((link, index) => (
          <li key={index}>
            {link.isExternal ? (
              <a 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-brand-grey hover:text-brand-blue transition-colors"
              >
                {link.text}
              </a>
            ) : (
              <Link to={link.url} className="text-brand-grey hover:text-brand-blue transition-colors">
                {link.text}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinksColumn;
